import React from "react";
import moment from "moment";
import $ from "jquery";
import api from "./../../Api.js";
import {Col,Row,Progress,Button,UncontrolledTooltip, DropdownToggle,
	DropdownMenu,
	DropdownItem,
	UncontrolledDropdown} from "reactstrap";
//import {Route,Switch} from "react-router-dom";

import Video from "./course/lessonType/Video.jsx";
import Iframev from "./course/lessonType/Iframev.jsx"

import Congratulations from "./course/lessonType/Congratulations.jsx";
import Quiz from "./course/lessonType/Quiz.jsx";
//import ReactPlayer from 'react-player';
//import LessonType from "./course/LessonType.jsx";
import Text from "./course/lessonType/Text.jsx";
import MagicTools from "./course/MagicTools.jsx";
import VideoChat from "./course/VideoChat.jsx";
import { connect } from 'react-redux';
import reduxHelper from "./../../helper/index.js";

import NotificationAlert from "react-notification-alert";
import Draggable from 'react-draggable';
import ReactPlayer from 'react-player';

class ViewLesson extends React.Component {
 
  	constructor(props){

  		super(props);

  		this.state = {zoomVideoHelper:0,zoomVideoHelper2:0,openVideoHelper:false,lockSaveLesson:false,completed:false,loadLesson:false,timerInit:false,lockTime:'00:00',height:'',width:'',lockNext:true};

  		this.getAtualLesson = this.getAtualLesson.bind(this)
  		this.initTime = this.initTime.bind(this);
  		this.next = this.next.bind(this);
		this.previous = this.previous.bind(this);
		this.helper = new reduxHelper(this.props);
  		this.verifyNextLesson = this.verifyNextLesson.bind(this);
		this.verifyPreviousLesson = this.verifyPreviousLesson.bind(this);
		this.next2 = this.next2.bind(this);
		this.verifyAccessNextLesson = this.verifyAccessNextLesson.bind(this);
		
		this.quiz = {"quizTitle":"Quiz principal de teste","quizSynopsis":"Você esta prestes a responder um quioz. Não se preocupe, se você ficou atento ao conteúdo anterior, suas chances de acertar este Quiz são muito grandes.","questions":[{"question":"<p><span style=\"color: rgb(33, 37, 41);\">TODOS OS APARELHOS ELETRÔNICOS UTILIZAM UMA LINGUAGEM PRÓPRIA DE COMPUTADOR. QUE LINGUAGEM É ESSA?</span></p>","questionType":"text","answers":["<p><span style=\"color: rgb(33, 37, 41);\">BINÁRIO</span></p>","<p><span style=\"color: rgb(33, 37, 41);\">LINGUAGEM DE PROGRAMAÇÃO.</span></p>","<p><span style=\"color: rgb(33, 37, 41);\">LÍNGUA DO P.</span></p>","<p><span style=\"color: rgb(33, 37, 41);\">LINGUAGEM C.</span></p>"],"correctAnswer":1},{"question":"<p><span style=\"color: rgb(33, 37, 41);\">O QUE OS CIENTISTAS CRIARAM PARA AJUDAR A DAR INSTRUÇÕES AOS COMPUTADORES DE UMA FORMA QUE OS HUMANOS TAMBÉM ENTENDAM?</span></p>","questionType":"text","answers":["<p><span style=\"color: rgb(33, 37, 41);\">O BINÁRIO</span></p>","<p><span style=\"color: rgb(33, 37, 41);\">A LINGUAGEM DE PROGRAMAÇÃO</span></p>","<p><span style=\"color: rgb(33, 37, 41);\">A CIÊNCIA.</span></p>","<p><span style=\"color: rgb(33, 37, 41);\">A INTERNET.</span></p>"],"correctAnswer":2},{"question":"<p><span style=\"color: rgb(33, 37, 41);\">QUAL DAS OPÇÕES&nbsp;</span><span style=\"color: rgb(33, 37, 41); background-color: rgb(255, 255, 0);\">PODEM&nbsp;</span><span style=\"color: rgb(33, 37, 41);\">SER CONSIDERADAS UM ALGORITMO.</span></p>","questionType":"text","answers":["<p><span style=\"color: rgb(33, 37, 41);\">ASSISTIR TELEVISÃO.</span></p>","<p><span style=\"color: rgb(33, 37, 41);\">LINGUAGEM DE PROGRAMAÇÃO.</span></p>","<p><span style=\"color: rgb(33, 37, 41);\">CÓDIGOS BINÁRIOS.</span></p>","<p><span style=\"color: rgb(33, 37, 41);\">RECEITA DE&nbsp;</span><span style=\"color: rgb(33, 37, 41); background-color: rgb(255, 255, 0);\">BOLO</span><span style=\"color: rgb(33, 37, 41);\">.</span></p>"],"correctAnswer":4}]};
		//this.quiz = JSON.parse(quiz);

  		window.viewlesson = this;

  	}

  	//Para pegar a lesson atual do usuario
  	async getAtualLesson(){

		await this.setState({loadLesson:false,openVideoHelper:false});

  		var lessonId =  this.props.lesson;
  		var unitId = this.props.unit;

  		var unitIndex = this.props.classroomState.units.findIndex(x => parseInt(x.id) === parseInt(unitId));
  		var unit = this.props.classroomState.units[unitIndex];

		var obj = {tags:window.classroom.state.course.id+' - '+unit.name};
		var pbjquery = window.parseQueryString();

		if(pbjquery.utm_source !== undefined){  obj.utm_source = pbjquery.utm_source; }
		if(pbjquery.utm_medium !== undefined){  obj.utm_medium = pbjquery.utm_medium; }
		if(pbjquery.utm_campaign !== undefined){ obj.utm_campaign = pbjquery.utm_campaign; }

		console.log('dis tag unit');
		console.log(obj);
		//window.mt('send','pageview',obj);

		obj.tags = obj.tags.replaceAll('"','');
		obj.tags = obj.tags.replaceAll("'","");

  	 	var lessons = unit.lessons;
  	 	var lessonIndex = lessons.findIndex(x => parseInt(x.id) === parseInt(lessonId));
 	 	//var lesson = unit.lessons[lessonIndex];

  		//await this.setState({lesson:lesson,lessons:unit.lessons,index:lessonIndex,loadLesson:true});

		var lesson = await this.helper.lesson().getLesson(this.props.lesson,"?complete=1");
		if(lesson.status === 200){

			//console.log(lesson.data);
			await this.setState({lockSaveLesson:false,lesson:lesson.data,lessons:unit.lessons,index:lessonIndex,loadLesson:true});

		}

  	}

  	//Para iniciar o tempolizador
  	async initTime(pass){

  		if(this.state.timerInit === true && pass === undefined){ return false; }

  		var time = window.lessonTime;

  		time = moment(time,'HH:mm:ss');
 		time.add(1, 'seconds');

		if(this.state.timerInit !== true){ await this.setState({timerInit:true}); }
 		
		window.lessonTime = time.format('HH:mm:ss');

		//setTimeout(function(){ this.initTime(1); }.bind(this), 1000);

		console.log(time.format('HH:mm:ss'));
		if(parseInt(time.format('ss')) > 30){

			this.next(true);

		}

  	}

 	componentDidMount(){

 		//console.log('deu did mount view lesson');

 		$(window).resize(function(){ this.resize(); }.bind(this));
		window.lessonTime = "00:00:00";

 		this.resize();
 		this.getAtualLesson();
 		//this.initTime();

		//força o envio do tempo

		window.intervalSumTime = setInterval(function(){ this.initTime(1); }.bind(this), 1000);


 	}

 	async componentDidUpdate(){ 

		if(this.state.loadLesson === false){ console.log('retirnou false'); return false; }

		//Caso a lesson seja diferente do que ta no state... ele busca o render atual
		if(this.state.lesson !== undefined){
 			
			if(parseInt(this.props.lesson) !== parseInt(this.state.lesson.id)){ 
				
				await this.getAtualLesson(); 
				console.log('foi');

			}

		}
 		//

 	}

 	resize(){ 

 		var altura = ($(window).height() - 44);
 		$("#lessonView").css('height',altura+"px"); 
 		this.setState({height:altura,width:$(window).width()});
  
 	}

	componentWillUnmount(){ 
		
		$(window).unbind();

		console.log('limpo window.intervalSumTime');
		clearInterval(window.intervalSumTime);
		
	 }

	//Para ir para a proxima lesson
	async next(onlyTime){

		//await this.setState({loadLesson:false});
		
		var obj = {};
		obj.lesson = this.state.lesson.id
		obj.classRoom = this.props.classroom;
		obj.time = window.lessonTime+'';
  
		if(onlyTime === true){

			obj.onlyTime = true;
			window.lessonTime = "00:00:00";

		}

		//verifica se a lesson é do tipo quiz
		if(this.state.lesson.type === 3 && onlyTime !== true){

			if($("#scoreQuiz").length !== 0){

				obj.quizPoints = $("#scoreQuiz").val();

				//Caso ja tenha progresso salvo, ele simplemente avança para proxima lesson]
				if(this.state.lesson.progress.length !== 0){

					this.next2();
					return false;
					
				}

			}

		}

		if(this.state.lockSaveLesson === false){

			await api.postProgress(obj).then(async (res) => {

				//var classRoom = this.props.classroom;
				var unit = this.props.unit;
				var lesson = this.state.lesson.id;

				//Para dar um push do progresso na lesson para não precisar pegar tudo de novo
				var indexUnit = this.props.classroomState.units.findIndex(x => parseInt(x.id) === parseInt(unit));
				var indexLesson = this.props.classroomState.units[indexUnit].lessons.findIndex(x => parseInt(x.id) === parseInt(lesson));

				this.props.classroomState.units[indexUnit].lessons[indexLesson].progress.push(res.data.progress);

				// Armazena badges e certificado concedidos automaticamente pelo backend
				if (res.data.awardedBadges && res.data.awardedBadges.length > 0) {
					this.setState({ awardedBadges: res.data.awardedBadges });

					// Toast para cada badge conquistada
					try {
						var self = this;
						res.data.awardedBadges.forEach(function (b, idx) {
							setTimeout(function () {
								if (self.refs.notificationAlert) {
									self.refs.notificationAlert.notificationAlert({
										place: 'tr',
										message: (
											<div className="alert-text">
												<span className="alert-title">🏆 Nova Badge!</span>
												<span> {b.name || 'Conquista desbloqueada'}</span>
											</div>
										),
										type: 'warning',
										icon: 'fas fa-award',
										autoDismiss: 6
									});
								}
							}, idx * 800);
						});
					} catch (e) { console.error('Erro toast badge:', e); }
				}
				// Toast de XP / level up
				if (res.data.xpAwarded && res.data.xpAwarded > 0) {
					try {
						if (this.refs.notificationAlert) {
							this.refs.notificationAlert.notificationAlert({
								place: 'tr',
								message: (
									<div className="alert-text">
										<span className="alert-title">⚡ +{res.data.xpAwarded} XP</span>
										<span> Continue assim!</span>
									</div>
								),
								type: 'info',
								icon: 'fas fa-bolt',
								autoDismiss: 4
							});
						}
					} catch (e) {}
				}
				if (res.data.leveledUp && res.data.newLevel) {
					try {
						if (this.refs.notificationAlert) {
							this.refs.notificationAlert.notificationAlert({
								place: 'tr',
								message: (
									<div className="alert-text">
										<span className="alert-title">🎉 LEVEL UP!</span>
										<span> Você alcançou {res.data.newLevel.name || ('Nível ' + res.data.newLevel.level)}</span>
									</div>
								),
								type: 'success',
								icon: 'fas fa-arrow-up',
								autoDismiss: 8
							});
						}
					} catch (e) {}
				}
				// Toast de gold ganho (regra 2: atividades dao XP + Gold)
				if (res.data.goldAwarded && res.data.goldAwarded > 0) {
					try {
						if (this.refs.notificationAlert) {
							this.refs.notificationAlert.notificationAlert({
								place: 'tr',
								message: (
									<div className="alert-text">
										<span className="alert-title">🪙 +{res.data.goldAwarded} Gold</span>
										<span> Gaste na Lojinha!</span>
									</div>
								),
								type: 'warning',
								icon: 'fas fa-coins',
								autoDismiss: 4
							});
						}
					} catch (e) {}
				}
				// Toast de HP recuperado (estudar cura o personagem)
				if (res.data.hpRegen && res.data.hpRegen.healed > 0) {
					try {
						if (this.refs.notificationAlert) {
							this.refs.notificationAlert.notificationAlert({
								place: 'tr',
								message: (
									<div className="alert-text">
										<span className="alert-title">💚 +{res.data.hpRegen.healed} HP</span>
										<span> Estudar cura! ({res.data.hpRegen.hpAfter}/{res.data.hpRegen.maxHp})</span>
									</div>
								),
								type: 'success',
								icon: 'fas fa-heart',
								autoDismiss: 4
							});
						}
					} catch (e) {}
				}
				// Toast missão completa
				if (res.data.missions && res.data.missions.completed && res.data.missions.completed.length > 0) {
					var self2 = this;
					res.data.missions.completed.forEach(function (m, i) {
						setTimeout(function () {
							try {
								if (self2.refs.notificationAlert) {
									self2.refs.notificationAlert.notificationAlert({
										place: 'tr',
										message: (
											<div className="alert-text">
												<span className="alert-title">🚩 Missão completa!</span>
												<span> {m.name} (+{m.xpAwarded} XP)</span>
											</div>
										),
										type: 'success',
										icon: 'fas fa-flag-checkered',
										autoDismiss: 7
									});
								}
							} catch (e) {}
						}, 1200 + i * 700);
					});
				}
				// Toast item cosmetico desbloqueado
				if (res.data.unlockedItems && res.data.unlockedItems.length > 0) {
					var self3 = this;
					res.data.unlockedItems.forEach(function (it, idx) {
						setTimeout(function () {
							try {
								if (self3.refs.notificationAlert) {
									self3.refs.notificationAlert.notificationAlert({
										place: 'tr',
										message: (
											<div className="alert-text">
												<span className="alert-title">🎁 Item desbloqueado!</span>
												<span> {it.itemName} ({it.rarity})</span>
											</div>
										),
										type: 'success',
										icon: 'fas fa-gift',
										autoDismiss: 7
									});
								}
							} catch (e) {}
						}, 2400 + idx * 700);
					});
				}

				// Toast streak milestone
				if (res.data.streak && res.data.streak.milestone) {
					try {
						if (this.refs.notificationAlert) {
							this.refs.notificationAlert.notificationAlert({
								place: 'tr',
								message: (
									<div className="alert-text">
										<span className="alert-title">🔥 {res.data.streak.currentStreak} dias!</span>
										<span> Streak épico continua!</span>
									</div>
								),
								type: 'warning',
								icon: 'fas fa-fire',
								autoDismiss: 8
							});
						}
					} catch (e) {}
				}

				if (res.data.certificate) {
					this.setState({ awardedCertificate: res.data.certificate });

					try {
						if (this.refs.notificationAlert) {
							this.refs.notificationAlert.notificationAlert({
								place: 'tr',
								message: (
									<div className="alert-text">
										<span className="alert-title">🎓 Certificado Emitido!</span>
										<span> Parabéns pela conclusão do curso!</span>
									</div>
								),
								type: 'success',
								icon: 'fas fa-graduation-cap',
								autoDismiss: 10
							});
						}
					} catch (e) { console.error('Erro toast cert:', e); }
				}

				if(onlyTime !== true){

					this.next2();

				}

				//Para fazer a comunicação em tempo real
				//obj.user = this.props.user.id;
				window.socket.emit('postProgress',res.data.progress);

			}).catch(error => {

				console.log(error.data);
				console.log(error);
				console.log(error.response); 

				if(onlyTime !== true){

					this.next2();

				}

				return false; 

			});

		}else{ 
			
			if(onlyTime !== true){

				this.next2();

			}

			
		 }
		

	}

	async next2(){

		var classRoom = this.props.classroom;
		var unit = this.props.unit;
		//var lesson = this.state.lesson.id;
			 
		//Busca a proxima lesson... e se tiver ja mandar pra la
		var next = await this.verifyNextLesson();
		if(next !== undefined){

			//verifica se é possível acessa lesson
			var acess = await this.verifyAccessNextLesson(next.id);
			console.log(acess);
		 
			if(acess.data.access === false && this.props.permissions_force.indexOf(35) === -1 ){

				//this.getAtualLesson();
				//window.lessonTime = "00:00:00";

				if(acess.data.type === "manual_lock"){

					let options = {place: "tc",message: (<div className="alert-text"><span className="alert-title" data-notify="title">O professor bloqueou a próxima atividade.</span><span data-notify="message">Você precisa aguardar até que ele libere.</span></div>),type:'default',icon: "fas fa-lock",autoDismiss: 7};
        			this.refs.notificationAlert.notificationAlert(options);

				}

				if(acess.data.type === "calendar"){

					let options = {place: "tc",message: (<div className="alert-text"><span className="alert-title" data-notify="title">Essa astividade não esta disponível.</span><span data-notify="message">Essa atividade estará disponível em {moment(acess.data.liberation_date,'YYYY-MM-DD').format('DD/MM/YYYY')} as {acess.data.liberation_time}</span></div>),type:'default',icon: "far fa-clock",autoDismiss: 7};
        			this.refs.notificationAlert.notificationAlert(options);

				}

				this.setState({lockSaveLesson:true,loadLesson:true});
				return false;

			}

			this.props.history.push('/myclassroom/'+classRoom+'/'+unit+'/'+next.id);
			await this.setState({lesson:next});
			this.getAtualLesson();
			window.lessonTime = "00:00:00";

		}

		//Caso seja undefined... significa que o cara concluiu
		if(next === undefined){

			await this.setState({completed:true});

		}

	}

	//Para ir para lesson anterior
	async previous(){

	 	var previous = this.verifyPreviousLesson();
		if(previous !== undefined){

			this.props.history.push('/myclassroom/'+this.props.classroom+'/'+this.props.unit+'/'+previous.id);
			this.setState({lesson:previous,completed:false});
			this.getAtualLesson();
			
		}

	}

	//Verifica se a proxima lesson existe
	verifyNextLesson(){

		var atual = this.state.lesson.id;
		var index = this.state.lessons.findIndex(x => parseInt(x.id) === parseInt(atual));

		//Retorna o proximo
		var nextLesson = this.state.lessons[(index+1)];

		return nextLesson;

	}

	async verifyAccessNextLesson(lesson){

		//Verifica la no servidor se pode acessa essa lesson
		var access = await this.helper.classroom().lessonIsAccessible(this.props.classroom,lesson);
		return access;

	}

	//Para verificar se a lesson aterior existe
	verifyPreviousLesson(){

		var atual = this.state.lesson.id;
		var index = this.state.lessons.findIndex(x => parseInt(x.id) === parseInt(atual));

		//Retorna o proximo
		return this.state.lessons[(index-1)];

	}

	//Verifica se a lesson anterior existe
	render(){
		
		var progresso = this.props.verifyProgressUnit(this.props.unit,'');
		
		var openVideoChat = undefined;
		var aovivo = false;
		if(this.state.openVideoChat === true){ openVideoChat = true; }
		 
		var index = this.props.classroom_option.map(function(x) {return x.name; }).indexOf('open_video_chat');
		if(index !== -1){ 

			for (let index = 0; index < this.props.classroom_option.length; index++) {
				 
				if(this.props.classroom_option[index].name === "open_video_chat" && this.props.classroom_option[index].value === "1"){

					openVideoChat = true;
					aovivo = true;

				}

			}
 
		}
 

		return(<React.Fragment>

				<div className="rna-wrapper"><NotificationAlert ref="notificationAlert" /></div>

				<style>{' .buttonOpenChat{ right: 174px !important; display:none;} '}</style>
					

					<div className="viewLessonReal"> 
			  			<Col  md={12}>
				  			<Row>
					  			<Col md="4" style={{display:'flex'}}>
					  				{ 

					  					(this.props.magictools.blockTop === false) &&
					  					<i onClick={ () => this.props.history.push('/myclassroom/'+this.props.classroom+'/'+this.props.unit) } className="fas fa-undo" style={{cursor:'pointer',color:'#fff',marginTop:'13px',fontSize:'20px'}}></i>
					  				
					  				}
					  				<h4 style={{color:'#fff',marginTop:'9px',marginLeft:'10px'}}>
						  				{
											(this.state.lesson !== undefined) &&
											<React.Fragment>
						  						<input readOnly style={{width:'100%',border:'none',backgroundColor:'#faebd700',color:'#fff',fontWeight:'600'}} id="namelessontool" type="text" value={this.state.lesson.name} />
												<UncontrolledTooltip placement="bottom" delay={0} target={'namelessontool'}>{this.state.lesson.name}</UncontrolledTooltip>
											 </React.Fragment>
										}
					  				</h4>
									<div>
										<img alt="..." style={{height:'30px',marginTop:'7px',marginLeft:'40px'}} src={this.props.user.photo} />
										<font style={{color:'#fff',fontWeight:'600',top:'3px',position:'relative',left:'6px'}} >{this.props.user.name}  </font>
									</div>

				  				</Col>
					  			<Col md="4">
						  			<div className="progress-wrapper" style={{paddingTop:'0px'}}>
							          	<div className="progress-info">
										  <div className="progress-label prgsa">
								              	<span style={{color:'#ffffff'}}>{this.props.translate['progresso_da_unit']}</span>
								            </div> 
								            <div className="progress-percentage">
								              	<span style={{color:'#fff'}}> {progresso.toFixed(0)}%</span>
								            </div>
							          	</div>
							          	<Progress max="100" value={progresso.toFixed(0)} color="success" style={{marginBottom:'5px'}}/>
							        </div>

								</Col>

								<Col md="4" style={{paddingTop:'10px'}}> 

									{
									
										(this.state.loadLesson === true) &&
										<React.Fragment>
										{

											(this.state.lesson.dataVideoHelper !== undefined) &&
											<Button className="bt_ajuda_video" onClick={ () => this.setState({openVideoHelper:!this.state.openVideoHelper}) } style={{}} color="primary" size="sm" type="button"><i class="far fa-play-circle"></i> Ajuda</Button>

										} 
										</React.Fragment>
										
										 
									}

									<Button onClick={() => window.chat.openChat() } className="bt_ajuda_video"  color="primary" size="sm" type="button"><i class="far fa-comment-dots"></i></Button>
								
								
								
								
		{

			(this.props.permissions_force.indexOf(18) !== -1) &&
			<UncontrolledDropdown >
				<DropdownToggle caret color="secondary" className="btn-sm">
					<i className="fas fa-hat-wizard"></i>
				</DropdownToggle>
				<DropdownMenu>
					<DropdownItem style={{cursor:'pointer'}} onClick={ () => this.props.dispatch({type:"OPEN_MODAL_TODOS_TELA"}) }><i className="fas fa-magnet"></i> Todos na tela</DropdownItem>
					<DropdownItem style={{cursor:'pointer'}} onClick={ () => this.props.dispatch({type:"OPEN_MODAL_CONFS_CLASSROOM"}) } ><i className="fas fa-cogs"></i> Configurações</DropdownItem>
					<DropdownItem style={{cursor:'pointer'}} onClick={ () => this.setState({openVideoChat:true}) }><i className="fas fa-headset"></i> Vídeo conferência</DropdownItem>
				</DropdownMenu>
			</UncontrolledDropdown>

		}				
		

		{

			(this.props.permissions_force.indexOf(18) !== -1) &&
			<React.Fragment>
			{

				(openVideoChat === true && aovivo === false) &&
				<Button onClick={ () => { this.props.insertOption('1',"open_video_chat"); } } style={{}} color="primary" size="sm" type="button"><i class="far fa-square"></i> AO VIVO</Button>

			}

			{

				(openVideoChat === true && aovivo === true) &&
				<Button onClick={ () => { this.props.deleteOption('1',"open_video_chat"); this.setState({openVideoChat:false}); } } style={{}} color="danger" size="sm" type="button"><i class="far fa-check-square"></i> AO VIVO</Button>

			}
			</React.Fragment>

		}
		 
		
       
								
								
								
								 









		 									<button onClick={() => window.comment.open({classroom:this.props.classroom, lesson:this.state.lesson.id, unit:this.props.unit})} className="btn btn-sm btn-primary ml-auto">
												Comentar
											</button>





						  			{
						  				(this.state.loadLesson === true && this.props.magictools.blockTop === false) &&
										<React.Fragment>
											
							  				{
							  					(this.verifyNextLesson() !== undefined) &&
												<React.Fragment>
													<Button className="completar_continuar" onClick={ () => this.next() } style={{float:'right',marginLeft:'5px'}} color="secondary" size="sm" type="button">{this.props.translate['completar_e_continuar']} <i className="fas fa-chevron-right"></i></Button>
					  							</React.Fragment>
											}
											{
							  					((this.verifyNextLesson() === undefined) && this.state.completed === false) &&
							  					<React.Fragment>									
													<Button className="concluir_unit" onClick={ () => this.next() } style={{float:'right',marginLeft:'5px'}} color="secondary" size="sm" type="button">{this.props.translate['concluir_unit']} <i className="fas fa-chevron-right"></i></Button>
				  								</React.Fragment>
											}
											{
							  					(this.verifyPreviousLesson() !== undefined) &&
								  				<React.Fragment>
													<Button t2="t2" onClick={ () => this.previous() } style={{float:'right',marginLeft:'5px'}} color="primary" size="sm" type="button"><i className="fas fa-chevron-left"></i> {this.props.translate['voltar']}</Button>
					  							</React.Fragment>
							  				}
						  				</React.Fragment>
									  }
									  
										{/*
												(this.state.completed === true) &&
												<React.Fragment>
													<Button t1="t1" onClick={ () => this.previous() } style={{float:'right',marginLeft:'5px'}} color="primary" size="sm" type="button"><i className="fas fa-chevron-left"></i> {this.props.translate['voltar']}</Button>
												</React.Fragment>*/
										
										}

					  			</Col>
				  			</Row>
			  			</Col>
			  			<Col className="lesson" id="lessonView" md={12} style={{padding:'0px'}}>
			  				{
			  					(this.state.loadLesson === true) &&
			  					<React.Fragment>
				  					{
				  						//Caso seja testo html
				  						((parseInt(this.state.lesson.type) === 0 || parseInt(this.state.lesson.type) === 1) && this.state.completed === false) &&
				  						<React.Fragment>
				  							<Text propsextend={this.props} state={this.state} next={this.next} />
				  						</React.Fragment>
				  							
				  					}
				  					{
				  						//Caso seja vídeo
				  						(parseInt(this.state.lesson.type) === 5 && this.state.completed === false) &&
				  						<React.Fragment>

											{ 

												(this.state.lesson.dataVideo !== undefined) &&
												<Video state={this.state} next={this.next} />

											}
											
				  							<style>{".viewLessonReal .lesson{overflow: hidden !important;}"}</style>


				  						</React.Fragment>
				  					}
				  					{
				  						//Caso seja quiz
				  						(parseInt(this.state.lesson.type) === 3 && this.state.completed === false) &&
				  						<React.Fragment>
				  							<Quiz propsextend={this.props} setState={(e) => this.setState(e)} state={this.state} next={this.next} />	
				  						</React.Fragment>
									}
									{
				  						//Caso seja iframe
				  						(parseInt(this.state.lesson.type) === 2 && this.state.completed === false) &&
				  						<React.Fragment>
				  							<Iframev propsextend={this.props} setState={(e) => this.setState(e)} state={this.state} next={this.next} />	
				  						</React.Fragment>
				  					}
			  					</React.Fragment>
							  }
							  
							{

								(this.state.completed === true) &&
								<React.Fragment>
								<Congratulations {...this.props} state={this.state} />
								</React.Fragment>

							}
							 
							{

			  					(this.props.permissions_force.indexOf(18) !== -1) &&
								<MagicTools
								
								deleteOption={ (a,b) => this.props.deleteOption(a,b) }
								insertOption={ (a,b) => this.props.insertOption(a,b) }
								 
								history={this.props.history} state={ this.state }  classRom={this.props.classroom} unit={this.props.unit} />

			  				} 

			  			</Col>
		  			</div>
					  
<style>{' .zoomVideoHelp{\
										cursor:pointer;\
										background-color: #536080; \
										color: #fff; \
										width: 30px; \
										justify-content: center; \
										border-radius:10px 10px 0px 0px;\
										margin-right:10px;\
										\
								} .videohelp iframe{ border-radius:10px; box-shadow: 0px 1px 3px -2px #000; \
													border-radius: 10px; \
													background-color: #536080; \
												} .div_drag .react-draggable{ background-image: linear-gradient(rgba(69, 69, 69, 0), rgba(0, 0, 0, 0)); } '}</style>
					  {

						(this.state.openVideoHelper === true) &&
						<React.Fragment>
								
								<Draggable axis="both" handle=".handle" defaultPosition={{x:window.$(".bt_ajuda_video").offset().left,y: -window.$(window).height() + 50 }} grid={[0.1,0.1]} scale={1}>
																	
										<div className="animated fadeIn videohelp" style={{zIndex:"999",position:'absolute'}}>
											<center style={{width:this.state.vw+'px'}}>

												<div style={{boxShadow:"rgb(255, 255, 255) 0px 1px 5px -2px",display:'flex',width:"220px",borderRadius:'10px 10px 0px 0px',backgroundColor:"#536080"}}>
													
													<div style={{marginLeft:"5px",color:"#fff",cursor:"grab",width:'112px'}} className="handle"><i className="fas fa-arrows-alt"></i> Segure e arraste</div>
													<div className="hvr-grow" onClick={() => this.setState({openVideoHelper:false})} style={{cursor:'pointer',color:"#fff",marginLeft:'40px'}}><i className="far fa-times-circle"></i> Fechar</div>

													<div style={{display:'flex',position:'absolute',marginLeft:'-90px',borderRadius:'10px 10px 0px 0px'}}> 
														{	(this.state.zoomVideoHelper >= 0.1) &&
															<div onClick={ () => { if(this.state.zoomVideoHelper === 0){ return false; } this.setState({zoomVideoHelper:this.state.zoomVideoHelper-0.3}) } } className="zoomVideoHelp"><i className="fas fa-search-minus"></i></div> 
														}
														{	(this.state.zoomVideoHelper <= 0.9) &&
															<div onClick={ () => { this.setState({zoomVideoHelper:this.state.zoomVideoHelper+0.3}) } } className="zoomVideoHelp"><i className="fas fa-search-plus"></i></div>
														}
														
													</div>
												
												</div>
												
												<ReactPlayer controls={true} onEnded={this.onEnded} ref="player_video" height={225 + ( 225 * this.state.zoomVideoHelper ) } width={460 + (460 * this.state.zoomVideoHelper )  } url={this.state.lesson.dataVideoHelper.url} playing />
										
											</center>
										</div>

								</Draggable>
							
						</React.Fragment>

					}


					{

						((this.props.permissions_force.indexOf(18) !== -1 && this.state.openVideoChat === true) || aovivo === true) &&

						<Draggable axis="both" handle=".handle" defaultPosition={{x:200,y: -window.$(window).height() + 50 }} grid={[0.1,0.1]} scale={1}>
																	
										<div className="animated fadeIn videohelp" style={{zIndex:"999",position:'absolute'}}>
											<center style={{width:this.state.vw+'px'}}>

												<div style={{boxShadow:"rgb(255, 255, 255) 0px 1px 5px -2px",display:'flex',width:"125px",borderRadius:'10px 10px 0px 0px',backgroundColor:"#536080"}}>
													
													<div style={{marginLeft:"5px",color:"#fff",cursor:"grab",width:'112px'}} className="handle"><i className="fas fa-arrows-alt"></i> Segure e arraste</div>
													{/*<div className="hvr-grow" onClick={() => this.setState({openVideoHelper:false})} style={{cursor:'pointer',color:"#fff",marginLeft:'40px'}}><i className="far fa-times-circle"></i> Fechar</div> */}

													<div style={{display:'flex',position:'absolute',marginLeft:'-90px',borderRadius:'10px 10px 0px 0px'}}> 
														{	(this.state.zoomVideoHelper2 >= 0.1) &&
															<div onClick={ () => { if(this.state.zoomVideoHelper2 === 0){ return false; } this.setState({zoomVideoHelper2:this.state.zoomVideoHelper2-0.3}) } } className="zoomVideoHelp"><i className="fas fa-search-minus"></i></div> 
														}
														{	(this.state.zoomVideoHelper2 <= 0.9) &&
															<div onClick={ () => { this.setState({zoomVideoHelper2:this.state.zoomVideoHelper2+0.3}) } } className="zoomVideoHelp"><i className="fas fa-search-plus"></i></div>
														}
														
													</div>
												
												</div>
												
												<VideoChat 
						
													state={this.state}
													setState={ (data) => this.setState(data) }
													classroom={this.props.classroom}
													height={225 + ( 225 * this.state.zoomVideoHelper2 ) } width={460 + (460 * this.state.zoomVideoHelper2 )  }

												/>
										
											</center>
										</div>

								</Draggable>

						 

					}


		</React.Fragment>);

	}

}
 
export default connect(state =>({

  languages: state.language,
  translate: state.translate,
  accesslevel: state.accesslevel,
  permission: state.permission,
  user: state.user,
  magictools: state.magictools,
  classroom_option: state.classroom_option

}))(ViewLesson);